/* ==========================================================================
   Design gallery (page template "designs"): every design with the visitor's own name.
   Tiles link to the designer: <product>?design=<id>&name=<name>
   Depends on window.OmaSticker, sticker-designs.js and sticker-art-more.js.
   ========================================================================== */
(function () {
  'use strict';

  var S = window.OmaSticker;
  if (!S || !S.designs || !S.designs.length) return;
  var NL = window.NL || { strings: {} };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function esc(s) { return window.NLUtil ? window.NLUtil.escapeHtml(s) : String(s); }

  var PAGE = 48;

  // Until the visitor types a name every tile shows a sample name of its own (children's names, grown-ups' names for the stylish designs)
  var KIDS = ['Aino', 'Eetu', 'Olivia', 'Leevi', 'Venla', 'Elias', 'Aada', 'Onni', 'Ella', 'Niilo', 'Sofia', 'Väinö', 'Helmi', 'Oskari', 'Lilja', 'Noel'];
  var GROWN = ['Kaarina', 'Eino', 'Raili', 'Marjatta', 'Pentti', 'Liisa', 'Hannu', 'Anneli', 'Matti', 'Sirkka'];
  // Stable per design (its place in the library), stepping through the list so that neighbours get different names
  var place = {};
  S.designs.forEach(function (d, i) { place[d.id] = i; });
  function sampleFor(d) {
    var grown = d.g === 'tyylikkaat';
    var list = grown ? GROWN : KIDS;
    return list[((place[d.id] || 0) * (grown ? 3 : 5)) % list.length];
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var target = root.getAttribute('data-target') || '/products/sekoitusarkki';
    var grid = $('[data-gallery-grid]', root), tabsBox = $('[data-gallery-tabs]', root), nameEl = $('[data-gallery-name]', root);
    var searchEl = $('[data-gallery-search]', root), countEl = $('[data-gallery-count]', root), moreBtn = $('[data-gallery-more]', root);
    var st = { tab: 'all', q: '', name: '', shown: PAGE };

    var defs = [['all', NL.strings.tabAll || 'Kaikki']].concat((S.designGroups || []).map(function (g) { return [g[0], g[1]]; }));
    tabsBox.innerHTML = defs.map(function (t) {
      return '<button type="button" role="tab" class="dtab" data-tab="' + t[0] + '" aria-selected="false">' + esc(t[1]) + '</button>';
    }).join('');

    function list() {
      return S.designs.filter(function (d) {
        if (st.q) return d.n.toLowerCase().indexOf(st.q) > -1 || d.id.indexOf(st.q) > -1;
        return st.tab === 'all' || d.g === st.tab;
      });
    }

    function draw() {
      var items = list();
      var shown = items.slice(0, st.shown);
      var nameOf = function (d) { return st.name || sampleFor(d); };
      var text = st.name || KIDS.concat(GROWN).join(' ');
      Array.prototype.forEach.call(tabsBox.children, function (b) {
        var on = b.dataset.tab === st.tab && !st.q;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var fontOf = function (d) { return d.f && S.byId(S.data.FONTS, d.f) ? d.f : 'blocky'; };
      var fonts = ['blocky'];
      shown.forEach(function (d) { if (fonts.indexOf(fontOf(d)) < 0) fonts.push(fontOf(d)); });
      S.ready(text, fonts).then(function () {
        grid.innerHTML = shown.map(function (d) {
          var t = S.toneOf(d, 0);
          var svg = S.render({
            shape: 'round', text: nameOf(d), font: fontOf(d), bg: t.bg, fg: t.fg, art: d.c ? '' : (d.a || ''),
            pattern: S.patternOf(d) || 'none', preview: true
          }).svg;
          var href = target + '?design=' + encodeURIComponent(d.id) + (d.f ? '&font=' + encodeURIComponent(d.f) : '') + (st.name ? '&name=' + encodeURIComponent(st.name) : '');
          var dots = d.c ? '<span class="dtile__dots" aria-hidden="true">' + d.c.slice(0, 6).map(function (c) { return '<i style="background:' + c[0] + '"></i>'; }).join('') + '</span>' : '';
          return '<a class="gtile" href="' + esc(href) + '"><span class="gtile__art">' + svg + dots + '</span><span class="gtile__name">' + esc(d.n) + '</span></a>';
        }).join('') || '<p class="dgrid__empty">' + esc((NL.strings.searchEmpty || '').replace('{{ q }}', st.q)) + '</p>';
      });
      if (countEl) {
        var cs = NL.strings || {};
        var tmpl = items.length === 1 && cs.libraryCountOne ? cs.libraryCountOne : (cs.libraryCount || '{{ total }}');
        countEl.textContent = tmpl.replace('{{ total }}', items.length);
      }
      moreBtn.hidden = items.length <= st.shown;
    }

    tabsBox.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tab]');
      if (!b) return;
      st.tab = b.dataset.tab; st.q = ''; st.shown = PAGE; searchEl.value = '';
      draw();
    });
    var timer;
    searchEl.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { st.q = searchEl.value.trim().toLowerCase(); st.shown = PAGE; draw(); }, 160);
    });
    nameEl.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { st.name = nameEl.value.trim(); draw(); }, 200);
    });
    moreBtn.addEventListener('click', function () { st.shown += PAGE; draw(); });

    // Take the name from the URL when the visitor comes from another page
    try {
      var q = new URLSearchParams(window.location.search).get('name');
      if (q) { st.name = q.slice(0, 20); nameEl.value = st.name; }
    } catch (e) {}
    draw();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-design-gallery]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
